export enum DashboardEntitiesEnum {
  DashboardHolidays = 'DashboardHolidays',
  DashboardMyTasks = 'DashboardMyTasks',
  DashboardUnassignedTasks = 'DashboardUnassignedTasks',

  DashboardHotOpportunities = 'DashboardHotOpportunities',
  DashboardEstimations = 'DashboardEstimations',
  DashboardProposals = 'DashboardProposals',
}
